module.exports = __webpack_public_path__ + "static/media/brand-refresh-cc-icon.0593525d.svg";